module.exports = "<app-level-info-list></app-level-info-list>\r\n"